import { render, staticRenderFns } from "./Memory.vue?vue&type=template&id=934ec63a&scoped=true"
import script from "./Memory.vue?vue&type=script&lang=js"
export * from "./Memory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "934ec63a",
  null
  
)

export default component.exports